<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-nav-bar
      title="Q8 Fuel on the Go"
      :has-back-button="true"
      :is-overlay="true"
    />
    <o-section>
      <h2 class="u-title">Krijg korting dankzij de Q8 smiles</h2>
      <p>
        Bij Q8 vertrek je na het tanken of shoppen met een glimlach. Want je
        spaart Smiles bij elke tankbeurt en bij elke aankoop in de shop.
      </p>
      <p>
        Je gespaarde Smiles ruil je in voor kortingen op een tankbeurt of
        aankoop in de shops bij Q8. Of je kiest voor een cadeaubon bij één van
        de Q8 smiles-partners: H&M, Kinepolis, Decathlon, ICI PARIS XL,
        Smartphoto en MediaMarkt.
      </p>
      <p class="u-primary u-strong">Hoe spaar je smiles?</p>
      <p>
        Smiles verdien je op twee manieren:
      </p>
      <ol>
        <li>Je krijgt 1 Smile per liter brandstof die je tankt.</li>
        <li>Je krijgt 1 Smile per euro die je uitgeeft in onze  shops.</li>
      </ol>
      <p class="u-primary u-strong">Hoe verzilver je smiles?</p>
      <p>
        Voldoende Smiles gespaard? Ruil ze in voor mooie kortingen aan de pomp
        of in de shop, of voor leuke cadeaus bij één van de Q8 smiles-partners.
      </p>
    </o-section>
  </o-view>
</template>

<script>
export default {
  name: 'Q8OnboardingCommercial'
}
</script>

<style lang="scss"></style>
